<template>
<div class="SpecialMgt">
    <div class="padding-20 bgc box-shadow" style="margin-bottom: 20px;font-size:16px;display: flex;justify-content: space-between;align-items: center;">
        <span>考试名称：{{param.examname}}</span>
        <el-button @click="cancel" type="text" size="small">返回考试列表</el-button>
    </div>
    <div class="padding-20 bgc box-shadow">
        <div class="filters">
            <div class="add flexstart">
                <el-button type="primary" @click="handleAdd">新建内容</el-button>
                <el-button type="primary" plain @click="handleDels">批量删除</el-button>
            </div>
            <div class="search">
                <el-date-picker v-model="timeSlot" type="daterange" value-format="yyyy-MM-dd" range-separator="-" class="condition"
                                start-placeholder="开始日期" end-placeholder="结束日期" clearable :picker-options="pickerDateFront"></el-date-picker>
                <el-input v-model="param.keyname" placeholder="请输入关键字" class="condition" clearable></el-input>
                <el-select v-model="param.newstypekind" placeholder="所属板块" class="condition" clearable>
                    <el-option v-for="item in newstypekindList" :key="item.code" :label="item.name"
                               :value="item.code"></el-option>
                </el-select>
                <el-select v-model="param.isrecommend" placeholder="是否推荐" class="condition" clearable>
                    <el-option v-for="item in isrecommendList" :key="item.code" :label="item.name"
                               :value="item.code"></el-option>
                </el-select>
                <el-select v-model="param.status" placeholder="状态" class="condition" clearable>
                    <el-option v-for="item in statusList" :key="item.code" :label="item.name"
                               :value="item.code"></el-option>
                </el-select>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%"  @select="handleSelectionChange">
                <el-table-column type="selection" width="50" :selectable="selectable"></el-table-column>
                <el-table-column prop="subject" label="标题" min-width="180px" class-name="title">
                    <template slot-scope="scope"><div class="text-ellipses"><div class="text">{{scope.row.subject}}</div></div></template>
                </el-table-column>
                <el-table-column prop="subjectname" label="所属科目" width="120px" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column prop="newstypekindname" label="所属板块" width="120px" class-name="tc" label-class-name="tc"></el-table-column>
                <!-- <el-table-column prop="authorname" label="作者名称" class-name="tc" label-class-name="tc"></el-table-column> -->
                <el-table-column prop="releasetime" label="发布日期" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column prop="viewcount" label="浏览量" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column prop="isrecommend" label="是否推荐" class-name="tc" label-class-name="tc">
                    <template slot-scope="scope">{{scope.row.isrecommend? '是' : '否'}}</template>
                </el-table-column>
                <el-table-column prop="status" label="状态" class-name="tc" label-class-name="tc">
                    <template slot-scope="scope"><span :class="[scope.row.status ? 'tc-green' : 'tc-grey']">{{scope.row.status ? '有效' : '无效'}}</span></template>
                </el-table-column>
                <!-- <el-table-column prop="hostname" label="发布人" class-name="tc" label-class-name="tc"></el-table-column> -->
                <el-table-column prop="datetime" label="创建时间" width="120px"  class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column label="操作" min-width="120px" label-class-name="tr">
                    <template slot-scope="scope">
                        <div class="tr">
                        <span class="separator-btn" v-if="scope.row.status">
                            <el-button @click.stop="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                        </span>
                        <span class="separator-btn" v-if="scope.row.status">
                            <el-button @click.stop="handleDel(scope.row)" type="text" size="small">删除</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click.stop="handleCopy(scope.row)" type="text" size="small">复制</el-button>
                        </span>
                        <span class="separator-btn" v-if="!scope.row.status">
                            <el-button @click.stop="handleView(scope.row)" type="text" size="small">查看</el-button>
                        </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="_getList" :current-page.sync="page.page" :page-size="page.pageSize"
            :pager-count="11" layout="prev, pager, next" :total="total">
            </el-pagination>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getQuestionbanktopiccontent, uploadQuestionbanktopiccontentStatus} from 'api/questionApi'
import {special} from 'api/enumCode'
export default {
    name: 'SpecialMgt',
    data() {
        return {
            tableData: [],
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            total: 0,
            timeSlot: null,
            newstypekindList: special.newstypekind,
            isrecommendList: special.isrecommend,
            statusList: special.status,
            param: {
                begintime: '',
                endtime: '',
                examcode: this.$route.query.examcode,
                examname: this.$route.query.examname,
                isrecommend: '',
                keyname: '',
                newstypekind: '',
                status: ''
            },
            selection: [],
            pickerDateFront: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                },
                onPick({ maxDate, minDate }) {
                    if (maxDate) {
                        if (maxDate - minDate > 30 * 24 * 60 * 60 * 1000) {
                            this.$message.error('时长不能超过30天，请重新选择')
                        }
                    }
                }
            }
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        cancel() {
            this.$router.back()
        },
        selectable(row, index) {
            return !!row.status
        },
        handleSelectionChange(selection) {
            this.selection= selection
        },
        handleQuery() {
            if (this.timeSlot) {
                let beginDate = new Date(this.timeSlot[0])
                let endDate = new Date(this.timeSlot[1])
                if (endDate- beginDate > 30 * 24 * 60 * 60 * 1000) {
                    this.$message.error('时长不能超过30天，请重新选择')
                    return false
                }
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            this.page.page = 1
            this._getList()
        },
        handleAdd() {
            this.$router.push({ name: 'SpecialEdit', query: {examcode: this.param.examcode}})
        },
        handleEdit(row) {
            this.$router.push({ name: 'SpecialEdit', query: {innerid: row.innerid, examcode: this.param.examcode}})
        },
        handleDels() {
            this.$confirm(`确认批量删除${this.selection.length}项内容`, '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                let list = []
                this.selection.forEach(obj => {
                    list.push(obj.innerid)
                })
                this._del(list.join(','))
            })
        },
        handleDel(row) {
            this.$confirm('确认删除', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this._del(row.innerid)
            })
        },
        handleCopy(row) {
            this.$router.push({ name: 'SpecialEdit', query: {innerid: row.innerid, examcode: this.param.examcode, isCopy: 1}})
        },
        handleView(row) {
            this.$router.push({ name: 'SpecialEdit', query: {innerid: row.innerid, examcode: this.param.examcode, isView: 1}})
        },
        _del(param) {
            this.setLoading(true)
            uploadQuestionbanktopiccontentStatus({
                data: {innerid: param},
                success: () => {
                    this.$message.success('删除成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getQuestionbanktopiccontent({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.SpecialMgt {
    .filters {
        .el-input,.el-input input {
            width: 120px;
            height: 32px;
        }
        .el-select .el-input,.el-select .el-input input {
            width: 108px;
            height: 32px;
        }
        .el-range-editor.el-input__inner input{
            width: 80px;
        }
        .el-range-editor.el-input__inner{
            width: 220px;
        }
        .el-range-separator{
            line-height: 24px;
        }
    }
}
</style>
